module.exports = __webpack_public_path__ + "static/media/logo.559cee49.png";